export default "__VITE_ASSET__Pc_26kgT__"